<template>
  <div class="section" v-if="labDevices.length">
    <h1 class="section-title"><span>设备展示</span></h1>
    <p class="section-tips">Equipment Display</p>
    <div class="section-content" v-loading="loading">
      <div class="section-content-items">
        <div
          class="item pointer"
          v-for="(item, index) in labDevices"
          :key="index"
          @click="deviceClick(item)"
        >
          <img
            class="item-img"
            :src="item.equipmentImage || $oss('images/common/empty-img.png')"
          />
          <div class="item-desc">
            <div class="item-name ellipsis">
              {{ item.equipmentName }}
            </div>
            <div class="item-brief ellipsis">{{ item.equipmentBrand }}</div>
          </div>
        </div>
      </div>
      <!-- 分页-->
      <Pagination
        :total="totalItem"
        :page="page"
        v-show="totalItem"
        @pageIndexChange="handlePageChange"
      />
      <DeviceDialog v-model="dialogShow" :data="currentData" />
    </div>
  </div>
</template>
<script>
import DeviceDialog from "./DeviceDialog.vue";
import { labDeviceList } from "@/api/lab";
import Pagination from "@/components/Pagination/index";

export default {
  name: "Devices",
  components: {
    DeviceDialog,
    Pagination,
  },
  data() {
    return {
      labDevices: [],
      loading: true,
      dialogShow: false,
      currentData: {},
      page: {
        pageIndex: 1,
        pageSize: 8,
      },
      totalItem: 0,
    };
  },
  created() {
    // 获取实验室设备列表
    this.getLabDevices();
  },
  methods: {
    // 获取实验室设备列表
    async getLabDevices() {
      this.loading = true;
      const { list, totalItem } = await this.$axios.post(labDeviceList, {
        laborarotyId: this.$route.query.id,
        ...this.page,
      });
      this.loading = false;
      this.labDevices = list;
      this.totalItem = totalItem;
    },
    deviceClick(data) {
      this.currentData = data;
      this.dialogShow = true;
    },
    handlePageChange(pageIndex) {
      this.page.pageIndex = pageIndex;
      this.getLabDevices();
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/variable";
.section-content {
  min-height: 500px;
  &-items {
    display: grid;
    grid-template-columns: repeat(4, 293px);
    gap: 15px;
    margin-bottom: 30px;
  }
}
.item {
  border: 1px solid #eeeff1;
  width: 293px;
  &-img {
    width: 100%;
    height: 222px;
    object-fit: cover;
    vertical-align: middle;
  }
  &-desc {
    padding: 16px;
    background: white;
    text-align: center;
  }
  &-name {
    font-weight: bold;
    color: #333333;
    margin-bottom: 4px;
    font-size: 16px;
  }
  &-brief {
    color: #999999;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
  }
}
</style>
